import type { IconNode } from '../types';

/**
 * @name kiwi
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNMTIgNnYxIiAvPgogIDxwYXRoIGQ9Im0xNSA5IDEtMSIgLz4KICA8cGF0aCBkPSJNMTcgMTJoMSIgLz4KICA8cGF0aCBkPSJtMTUgMTUgMSAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxN3YxIiAvPgogIDxwYXRoIGQ9Im04IDE2IDEtMSIgLz4KICA8cGF0aCBkPSJNNiAxMmgxIiAvPgogIDxwYXRoIGQ9Im04IDggMSAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/kiwi
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const kiwi: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M12 6v1', key: '1xj613' }],
  ['path', { d: 'm15 9 1-1', key: 'shj47' }],
  ['path', { d: 'M17 12h1', key: 'jz1enf' }],
  ['path', { d: 'm15 15 1 1', key: '1hqfe6' }],
  ['path', { d: 'M12 17v1', key: 'y8y3f9' }],
  ['path', { d: 'm8 16 1-1', key: 'hbzh1h' }],
  ['path', { d: 'M6 12h1', key: '4504rf' }],
  ['path', { d: 'm8 8 1 1', key: 'clr8k7' }],
];

export default kiwi;
